export default __webpack_public_path__ + "static/media/b_problemSolving_small.952e6537.png";